import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import NotificationsListView from "./notifications-list.html";
import NotificationsEditView from "./notifications-edit.html";


angular.module("notifications", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('notifications', {
                url: "/notifications",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('notifications.list', {
                url: "/list",
                controller: "NotificationsListCtrl",
                template: NotificationsListView,
                resolve: {
                    entity_type: [function () { return "events"; }],
                },
                cache: false,
                data: { pageTitle: 'Notificaciones' },
                requiredPermission: ["NOTIFICATIONS_READ"]
            })
            .state('notifications.edit', {
                url: "/edit/:notificationId",
                controller: "NotificationsEditCtrl",
                template: NotificationsEditView,
                cache: false,
                data: { pageTitle: 'Notificación' },
                requiredPermission: ["NOTIFICATIONS_READ"]
            });
    }]);